<template>
  <v-app>
    <v-app-bar app color="blue" dark>
      <img src="./assets/reisekostenrechner_logo.svg" class="d-none d-print-block" width="40" />
      <div class="d-flex align-center">

          <a href="https://www.amz-steuer.de" target="_blank" class="wrapper py-1 px-1 mr-5">
          <v-img
            alt="Zur Startseite der AMZ Steuerberatung."
            class="shrink d-print-none"
            contain
            src="./assets/reisekostenrechner_logo.svg"
            transition="scale-transition"
            width="40"/>
          </a>

        <h1 class="headline font-weight-light text-uppercase">Reisekostenrechner <small class="d-none d-md-inline-block">(In- und Ausland)</small>
          <span class="sub-headline">Rechtsstand 01.01.2026</span>
        </h1>
      </div>

      <v-spacer></v-spacer>
      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn outlined v-bind="attrs" v-on="on" class="d-sm-none d-print-none">
            AMZ
          </v-btn>
        </template>
        <v-list>
          <v-list-item>
            <v-list-item-title>
              <a class="text-decoration-none" href="https://personalfragebogen.online" target="_blank">Zum Personalfragebogen</a>
            </v-list-item-title>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item>
            <v-list-item-title>
              <a class="text-decoration-none" href="https://www.amz-steuer.de" target="_blank">Zur AMZ-Website</a>
            </v-list-item-title>

          </v-list-item>
        </v-list>
      </v-menu>
      <div class="d-sm-flex d-none d-print-none">
        <v-btn outlined class="mr-2" href="https://personalfragebogen.online" target="_blank">Personalfragebogen</v-btn>
        <v-btn outlined href="https://www.amz-steuer.de" target="_blank">
          AMZ
        </v-btn>
      </div>

    </v-app-bar>

    <v-content class="grey lighten-4">
      <transition name="scroll-x-transition">
        <router-view/>
      </transition>
    </v-content>
  </v-app>
</template>

<style scoped>
  .wrapper {
    background-color: white;
    border-radius: 10px;
  }

  a.link-white {
    color: #fff !important;
    text-decoration: none;
  }
  .headline {
    line-height: 1.1;
  }
  .sub-headline {
    font-size: 12px !important;
    font-weight: normal !important;
    text-transform: none;
    display: block;
  }

  @media screen and (max-width: 700px) {
    .headline {
      font-size: 16px !important;
      line-height: 0.9;
      font-weight: normal !important;
    }
  }
  
  @media print {
    .headline {
      font-size: 16px !important;
    }
  }
</style>

<script>

export default {
  name: 'App',

  data: () => ({
    //
  }),
};
</script>

